import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import axios from "axios";
import swal from "sweetalert2";
import { globalState, baseUrl, price, contact, accessTokenKey, isPremium } from "../../utils/config";

import "../../assets/lib/animate/animate.min.css";
// import "../../assets/lib/owlcarousel/assets/owl.carousel.css";
import "../../assets/css/bootstrap.min.css";
import "../../assets/css/bootstrap-icons.css";
import "../../assets/fontawesome/css/all.css";
import "../../assets/css/style.css";

import "../../assets/js/bootstrap.bundle.js";
import "../../assets/js/jquery.js";
import "../../assets/lib/wow/wow.min.js";
// import "../../assets/lib/easing/easing.min.js";
// import "../../assets/lib/waypoints/waypoints.min.js";
// import "../../assets/lib/owlcarousel/owl.carousel.js";
import "../../assets/js/main.js";

function Header() {

    const navigate = useNavigate();
    const location = useLocation();
    const [state, setState] = useState(globalState.state);

    async function onInit() {
        try {
            const response = await axios.post(
                baseUrl + "/api/me",
                null,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const user = response.data.user;
                const newMessages = response.data.new_messages;

                let totalNotifications = user.jobs_notifications + newMessages;

                globalState.setState({
                    user: user,
                    newMessages: newMessages,
                    totalNotifications: totalNotifications
                });
            } else {
                // swal.fire("Error", response.data.message, "error")
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    async function doLogout() {
        globalState.setState({
            user: null
        });

        try {
            const response = await axios.post(
                baseUrl + "/api/logout",
                null,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                localStorage.removeItem(accessTokenKey);
                navigate("/");
            } else {
                // swal.fire("Error", response.data.message, "error")
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    function isJobLink() {
        return location.pathname === "/jobs"
            || location.pathname === "/my-applied"
            || location.pathname === "/my";
    }

    useEffect(function () {
        onInit();

        globalState.listen(function (newState, updatedState) {
            setState(newState);
        });
    }, []);

    // useEffect(function () {
    //     setTotalNotifications((state.user?.jobs_notifications || 0) + (state.newMessages || 0));
    // }, [state.newMessages]);

    return (
        <>
            {/*<header className="navbar">
                <div className="navbar__container">
                    <button type="button" className="navbar__buy-button btn btn-primary"
                        onClick={ function () {
                            if (typeof window.tidioChatApi !== "undefined") {
                                window.tidioChatApi.open();
                            } else {
                                window.location.href = "mailto:" + contact.email;
                            }
                        } }>Buy Now – ${ price }</button>
                </div>
            </header>*/}

            <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
                <Link to="/" className="navbar-brand d-flex align-items-center text-center py-0 px-4 px-lg-5">
                    <h1 className="m-0 text-primary">JobEntry</h1>
                </Link>
                <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto p-4 p-lg-0">
                        <Link to="/" className={ `nav-item nav-link ${ location.pathname === '/' ? 'active' : '' }` }>Home</Link>
                        <Link to="/about" className={ `nav-item nav-link ${ location.pathname === '/about' ? 'active' : '' }` }>About</Link>

                        <div className="nav-item dropdown">
                            <a href="#" className={ `nav-link dropdown-toggle ${ isJobLink() ? 'active' : '' }` } data-bs-toggle="dropdown">
                                Jobs
                            </a>
                            
                            <div className="dropdown-menu rounded-0 m-0">
                                <Link to="/jobs" className={ `dropdown-item ${ location.pathname === '/jobs' ? 'active' : '' }` }>Jobs</Link>
                                
                                { state.user?.type == "job_seeker" && (
                                    <Link to="/my-applied" className={ `dropdown-item ${ location.pathname === '/my-applied' ? 'active' : '' }` }>My Applied</Link>
                                ) }
                                
                                { state.user?.type == "recruiter" && (
                                    <Link to="/my" className={ `dropdown-item ${ location.pathname === '/my' ? 'active' : '' }` }>My Jobs</Link>
                                ) }
                            </div>
                        </div>

                        <Link to="/contact" className="nav-item nav-link">Contact</Link>

                        { !isPremium && (
                            <Link to="/pricing" className="nav-item nav-link">Pricing</Link>
                        ) }

                        { state.user == null ? (
                            <>
                                <Link to="/login" className="nav-item nav-link">Login</Link>
                                <Link to="signup" className="nav-item nav-link">Sign Up</Link>
                            </>
                        ) : (
                            <div className="nav-item dropdown">
                                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                                    { state.user.name }

                                    { state.totalNotifications > 0 && (
                                        <span className="text-danger ms-2">
                                            <i className="fa fa-bell"></i>&nbsp;
                                            ({ state.totalNotifications })
                                        </span>
                                    ) }
                                </a>
                                
                                <div className="dropdown-menu rounded-0 m-0">
                                    <Link to="/profile" className="dropdown-item">
                                        My Profile
                                    </Link>

                                    <Link to="/notifications" className="dropdown-item">
                                        Notifications

                                        { state.user.jobs_notifications > 0 && (
                                            <span className="text-danger ms-2">
                                                <i className="fa fa-bell"></i>&nbsp;
                                                ({ state.user.jobs_notifications })
                                            </span>
                                        ) }
                                    </Link>

                                    <Link to="/inbox" className="dropdown-item">
                                        Inbox

                                        { state.newMessages > 0 && (
                                            <span className="text-danger ms-2">
                                                <i className="fa fa-message"></i>&nbsp;
                                                ({ state.newMessages })
                                            </span>
                                        ) }
                                    </Link>

                                    { state.user.type == "job_seeker" && (
                                        <>
                                            <Link to="/cv-manager" className="dropdown-item">
                                                CV Manager
                                            </Link>

                                            <Link to="/bookmarks" className="dropdown-item">
                                                Bookmarks
                                            </Link>

                                            <Link to="/followings" className="dropdown-item">
                                                Followings
                                            </Link>
                                        </>
                                    ) }
                                    
                                    <a href="#" onClick={ function (event) {
                                        event.preventDefault();
                                        doLogout();
                                    } } className="dropdown-item">Logout</a>
                                </div>
                            </div>
                        ) }
                    </div>

                    <Link to="/post" className="btn btn-primary rounded-0 py-4 px-lg-5 d-lg-block">Post A Job<i className="fa fa-arrow-right ms-3"></i></Link>
                </div>
            </nav>
        </>
    );
}

export default Header;